import { Box } from '@mui/material';
import Image from 'next/image';
import React from 'react';
import { getAuctioneerLogo } from '@src/helpers/image-helpers';

const PartnerLogo = ({ image, name }) => {
    return (
        <>
            <Box display='flex' position='relative' height={60}>
                {image && <Image alt='partner-logo' layout='fill' objectFit='contain' src={getAuctioneerLogo(image)} />}
            </Box>
            <Box alignSelf='center' sx={{ fontWeight: 500 }}>
                {name}
            </Box>
        </>
    );
};

export default PartnerLogo;
